import { DateTime } from 'luxon'

export enum eTypeReturnModal {
  ASN_BLOG_MODAL = 1,
  ASN_VIEW_MODAL = 2,
  ASN_RECEIVE_MODAL = 3,
  ASN_DELETE_MODAL = 4
}

export interface SelectedFiltersValues {
  supplierId?: number | undefined
  asnId?: number | null
  workOrderId: number | null
  typeAsnIncomeId: number | null
  externalOrderId: number | null
  initialDate: DateTime | null
  finalDate: DateTime | null
  warehouseId: number | null
}
